import { compute_rest_props } from 'svelte/internal';
import { writable } from 'svelte/store';
import { OFILTERSCONST, MOBILE_VIEW_SIZE } from './constants.js';
import { fCalculateBMI, fConvertToFtIn } from './utils.js';

let data;
export const apiurl = writable('');
export const lastUpdated = writable({'lastUpdated':'', 'lastUpdatedText':''});
export const lastUpdatedText = writable('');

export const bIsMobileStore = writable(false);
export const searchData = writable(data);

const oFilters = {...OFILTERSCONST};
export const oFilterStore = writable({...OFILTERSCONST});
export const bIsFilterStore = writable(false);
export const bIsRecReset = writable(false);

export const arrBookmarkedRec = writable(JSON.parse(localStorage.getItem("bookmarked")) || []);

// Get Saved Filter Keys from localStorage
export const arrSavedFilterKeys = writable(Object.keys(localStorage).filter(key => key.includes('wv-filter-')).map(key => key.substring(10)).sort());

export const query = writable('');

export const fIsMetric = () => {
  if(document.cookie) {
    // breakdown cookies into object arr
    var cookies = document.cookie.split(';')
    .map(cookie => cookie.split('='))
    .reduce((acc, [key, value]) => ({...acc, [key.trim()]: decodeURIComponent(value)}), {});
    if (cookies.ismetric) {
        return (String(cookies.ismetric).toLowerCase() === 'true');
    } else {
        return false;
    }
  }
  return false;
}

export const fFilterDataByInput = (searchData, oFilterStore) => {
  if (!searchData || !oFilterStore) {return false}
  
  /* Filter JSON Data
   * RiskName - "Pregnant", "Tobacco user", "Sexually Active"
   * sex - "male", "female", "men and women"
   * grade - i.e. "A"
   */
  /* Filters 
   * sex val: ["Male", "Female"]
   */

  let specificRecIds = [];
  let keywords = "";
  let arrsKeyword =[];

  if (oFilterStore.keywords && oFilterStore.keywords.values.length > 0) {
    keywords = oFilterStore.keywords.values[0];
    keywords = keywords && keywords.toLowerCase();
    // split keywords by space and quotes
    arrsKeyword = keywords && keywords.match(/(".*?"|[^"\s]+)+(?=\s*|\s*$)/g);

    const genRecValues = searchData && Object.values(searchData.generalRecommendations);


    // Search Keywords OR
    if (arrsKeyword && arrsKeyword.length > 0) {
      genRecValues && genRecValues.forEach(genRec => {
        arrsKeyword && arrsKeyword.forEach(keyword => {
          const key = keyword.replace(/['"]+/g, '');
          if (genRec.title.toLowerCase().includes(key) ||
              genRec.keywords.toLowerCase().includes(key)) {
                specificRecIds = [...specificRecIds, ...genRec.specific];
          }
        });
      });
    }
  }

  searchData.filteredSpecificRecommendations = searchData && searchData.specificRecommendations.filter(rec => {
    /*
    Tobacco User
    Y => no filter; return all
    N => return recommendations WITHOUT riskName "Tobacco"

    Pregnant
    Y => no filter; return all
    N => return recommendations WITHOUT riskName "Pregant"

    Sexually Active
    Y => no filter; return all
    N => return recommendations WITHOUT riskName "Sexually Active"

    When the recommendation sex is men and women, this filter is returned when the user selects Male or Female filter.
    */
   
   // User input values
   const ageInput = oFilterStore.age && oFilterStore.age.values[0];
   const iHeightVal = oFilterStore.height.values.length > 0 && oFilterStore.height.values[0];
   const iWeightVal = oFilterStore.weight.values.length > 0 && oFilterStore.weight.values[0];
   const oBMI = (!iHeightVal || !iWeightVal) ? null : fCalculateBMI(oFilterStore.weight.values[0], oFilterStore.height.values[0]);
   const sGender = oFilterStore.sex && oFilterStore.sex.values.length > 0 && oFilterStore.sex.values[0].toLowerCase(); // male, female

   // Convert height in inches to feet and inches format
   if (oFilterStore.heightFt.values.length < 1 && oFilterStore.heightIn.values.length < 1) {
    const arrHeightVal = fConvertToFtIn(iHeightVal);
    if(arrHeightVal && arrHeightVal.length > 0) {
      oFilterStore.heightFt.values = [arrHeightVal[0]];
      oFilterStore.heightIn.values = [arrHeightVal[1]];
    }
   }

   if (
     (oFilterStore.grade.values.length < 1
       || oFilterStore.grade.values.includes(rec.grade)) &&
      // user input, excluding every items with BMI range other than the based on the input
      (!oBMI || !rec.bmi || oBMI && oBMI.categories.includes(rec.bmi) ) &&
      (!ageInput && ageInput !== 0 || (rec.ageRange[0] <= ageInput && ageInput <= rec.ageRange[1])) &&
      (!sGender || rec.sex == sGender || sGender && rec.sex == "men and women") &&
      (!sGender || sGender === 'male' && rec.riskName !== "Pregnant" || sGender === 'female' ||  sGender && rec.sex == "men and women") &&
      (oFilterStore.pregnant.values.length < 1 || oFilterStore.pregnant.values.includes("Y") || (oFilterStore.pregnant.values.includes("N") && rec.riskName !== "Pregnant")) &&
      (oFilterStore.tobacco.values.length < 1 || oFilterStore.tobacco.values.includes("Y") || (oFilterStore.tobacco.values.includes("N") && rec.riskName !== "Tobacco user")) &&
      (oFilterStore.sexuallyActive.values.length < 1 || oFilterStore.sexuallyActive.values.includes("Y") || (oFilterStore.sexuallyActive.values.includes("N") && rec.riskName !== "Sexually Active")) &&
      (arrsKeyword.length < 1 || (arrsKeyword.length > 0 && specificRecIds.includes(rec.id)))
   ) {
     return true;
   } else {
     return false;
   }
  });
  return searchData;
}

export const fMyBookmarkedRecData = (searchData) => {
  if(!searchData) {return;}
  searchData.specificRecommendations.filter(rec => {
    if (arrBookmarkedRecommendations.indexOf(rec.id) > -1) {
      rec.bookmark = true;
      return true;
    } 
    return false;
  });
  return searchData;
}